import React, { useEffect, useState } from "react";
import { useLoginFakeMutation } from "src/services";
import { useNavigate } from "react-router-dom";
import { Flex } from "@nubeteck/components";
import { Content } from "antd/es/layout/layout";
import { LargeHeadingStyled, SectionHeaderStyled } from "src/components/custom/texts/texts.styled";
import { Button, Form, Input, Skeleton } from "antd";
import { useErrorStudentIdRequiredToast } from "src/constants";
import { getPreRegistrationPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { StrapiError } from "../../StrapiError";

const FakeLogin = () => {
  const [form] = Form.useForm<any>();
  const { validateFields } = form;
  const [loginFake, { data, isSuccess, isLoading }] = useLoginFakeMutation();
  const navigate = useNavigate();
  const { locale } = useLocale();
  const [preRegistrationPage, setPreRegistrationPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError]= useState<boolean>(false);
  const showErrorStudentIdRequiredToast = useErrorStudentIdRequiredToast();
  useEffect(() => {
    if (isSuccess) {
      localStorage.setItem("matriculaAdministrativa", "true");
      localStorage.setItem("token", data.data.token);
      localStorage.setItem("refreshToken", JSON.stringify(data.data.refreshToken));
      navigate("/subjects-registration/initial");
      window.location.reload();
    }
  }, [data, isSuccess, navigate]);

  const submit = () => {
    validateFields(["matricula"])
      .then((values) => {
        if (values) {
          loginFake(values);
        }
      })
      .catch(() => {
        showErrorStudentIdRequiredToast();
      });
  };

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setPreRegistrationPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    getPreRegistrationPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setPreRegistrationPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setPreRegistrationPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setPreRegistrationPage(null);
      }}
    />;
  }

  return (
    <Flex style={{ flexDirection: "column", width: "100%", alignSelf: "flex-start" }}>
      <Content style={{ marginTop: "16px" }}>
        <SectionHeaderStyled>
          <LargeHeadingStyled>{isLoadingContent ? <Skeleton.Input active size="large" style={{ width: 300 }} /> : (preRegistrationPage?.title || "Matricular como usuario estudiante")}</LargeHeadingStyled>
        </SectionHeaderStyled>
        <Flex style={{ gap: "15px" }}>
          <Form
            form={form}
            layout="vertical"
            onFinish={submit}
            style={{ display: "flex", flexDirection: "column", gap: 16 }}
            initialValues={{
              id: 1,
            }}
          >
            <Form.Item
              name="matricula"
              label={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 200 }} /> : (preRegistrationPage?.requered || "ID del estudiante")}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Este campo es requerido",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Button type="primary" size="large" htmlType="submit" loading={isLoading}>
              {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (preRegistrationPage?.enter_button || "Ingresar")}
            </Button>
          </Form>
        </Flex>
      </Content>
    </Flex>
  );
};

export default FakeLogin;
